import { MakeLogicType, actions, kea, path, reducers } from 'kea'

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface deletedRecordingsLogicValues {
    deletedRecordingIds: Set<string>
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface deletedRecordingsLogicActions {
    addDeletedRecordings: (ids: string[]) => {
        ids: string[]
    }
}

export type deletedRecordingsLogicType = MakeLogicType<deletedRecordingsLogicValues, deletedRecordingsLogicActions>

export const deletedRecordingsLogic = kea<deletedRecordingsLogicType>([
    path(['scenes', 'session-recordings', 'deletedRecordingsLogic']),
    actions({
        addDeletedRecordings: (ids: string[]) => ({ ids }),
    }),
    reducers({
        deletedRecordingIds: [
            new Set<string>(),
            {
                addDeletedRecordings: (state, { ids }) => {
                    const next = new Set(state)
                    for (const id of ids) {
                        next.add(id)
                    }
                    return next
                },
            },
        ],
    }),
])
